<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-15 10:35:09
 * @LastEditTime: 2021-08-26 14:39:14
 -->
<template>
  <div class="academy-addedit-wrap">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="200px"
      class="ruleForm"
    >
      <el-form-item label="项目名称：" prop="projectName">
        <el-tooltip
          effect="dark"
          :content="ruleForm.projectName"
          placement="top"
        >
          <el-input v-model="ruleForm.projectName" disabled />
        </el-tooltip>
      </el-form-item>
      <el-form-item label="接单企业：" prop="enterpriseName">
        <el-input v-model="ruleForm.enterpriseName" disabled />
      </el-form-item>
      <!-- <el-form-item label="封面图：" prop="bgUrl">
        <UploadImgOne :initUrl="ruleForm.bgUrl" @upload-done="waitPicDone" :ifDisable="ifDisable"></UploadImgOne>
      </el-form-item>-->

      <el-form-item
        class="input-width"
        label="项目结算单价（税前）："
        prop="price"
      >
        <el-input
          class="yuan"
          v-model="ruleForm.price"
          :disabled="ifDisable"
        ></el-input>
      </el-form-item>
      <!--      todo 添加税率字段,匹配对应的验证器 -->
      <el-form-item class="input-width" label="税率：" prop="contractScale">
        <el-input
          class="percentage"
          v-model="ruleForm.contractScale"
          :disabled="ifDisable"
        ></el-input>
      </el-form-item>
      <el-form-item class="input-width" label="总任务量：" prop="taskSum">
        <el-input
          v-model="ruleForm.taskSum"
          maxlength="10"
          :disabled="ifDisable"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="订单支付审核："
        v-if="ruleForm.isOrderAudit == 1 && ruleForm.taxCollectionPattern == 4"
      >
        <el-button
          plain
          style="color: #3a8ee6;border-color: #3a8ee6;cursor: default;"
        >
          需审核
        </el-button>
        <span>
          项目支付给自然人时需进行审核
        </span>
      </el-form-item>
      <el-form-item class="button-margin-top">
        <el-button
          type="primary"
          @click="submitForm('ruleForm', 0)"
          :loading="btLoading"
          :disabled="ifDisable"
        >
          保存
        </el-button>
        <el-button
          type="primary"
          @click="db"
          :loading="btLoading"
          :disabled="ifDisable"
        >
          {{ isConfirm ? '已确认' : '确认' }}
        </el-button>
        <next-project-btn :info="ruleForm" :submitFn="db"></next-project-btn>
        <!-- <el-button type="primary" @click="resetForm('ruleForm')">取消</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { btLoading } from '@/Mixin/btLoading';
/**
 * dbCon
 * setLocalProjectStatus db (methods)
 * isConfirm ifDisable (computed)
 *  */
import { dbCon } from '@/Mixin/doubleConfirm';
import { project } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import UploadImgOne from '@/components/Common/UploadImgOne.vue';
import { moneyComplete, moneyInt } from '@/tools/money';
import { priceFilter, isInteger, checkTax } from '@/tools/formCheck';
import nextProjectBtn from '@/components/Judge/NextProjectBtn.vue';
export default {
  mixins: [btLoading, dbCon],
  data() {
    const checkTransmitList = (rule, value, callback) => {
      if (value[0] == '') {
        callback(new Error('传递信息不能为空'));
      } else {
        callback();
      }
    };
    const checkFeedbackList = (rule, value, callback) => {
      if (value[0] == '') {
        callback(new Error('传递信息不能为空'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        projectName: '',
        bgUrl: '',
        price: '',
        taskSum: '',
        enterpriseName: '',
        id: '',
        projectStatus: '',
        contractScale: null
      },
      // 校验
      rules: {
        price: [
          {
            validator: priceFilter,
            trigger: 'blur',
            required: true
          }
        ],
        enterpriseName: [
          {
            trigger: 'blur',
            message: '接单企业不能为空',
            required: true
          }
        ],
        taskSum: [
          {
            required: true,
            validator: isInteger,
            trigger: 'blur'
          }
        ],
        enterpriseId: [
          {
            required: true,
            message: '请选择企业',
            trigger: 'blur'
          }
        ],
        projectName: [
          {
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }
        ],
        bgUrl: [
          {
            required: true,
            message: '请上传封面图',
            trigger: 'blur'
          }
        ],
        contractScale: [
          {
            required: true,
            validator: checkTax,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  components: {
    nextProjectBtn,
    dicSelect,
    UploadImgOne
  },
  methods: {
    waitPicDone(v) {
      this.ruleForm.bgUrl = v;
    },
    resetForm(formName) {
      this.ruleForm.projectStatus = !(type === 0);
    },
    submitForm(formName, type) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // 改变按钮状态
            // 混合对象 格式化数据
            let data = Object.assign({}, this.ruleForm);
            data.price = moneyComplete(data.price);
            data.type = type;
            project
              .addUpdatePatientProject(data)
              .then(res => {
                this.$notify({
                  title: '成功',
                  message: type === 0 ? '保存成功' : '提交成功',
                  type: 'success'
                });
                resolve('submit_success');
                this.setLocalProjectStatus(type);
              })
              .catch(() => {
                reject('submit_error');
              });
          } else {
            reject('submit_error');
            return false;
          }
        });
      });
    }
  },
  computed: {},
  watch: {
    'ruleForm.contractScale'(value) {
      if (/\d+\.\d{3,}$/g.test('' + value)) {
        this.ruleForm.contractScale = Number(value).toFixed(2);
      }
      if (/\s/g.test(`${value}`)) {
        this.ruleForm.contractScale = `${value}`.replace(/\s/g, '');
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      project
        .loadPatientProject({
          id: this.$route.query.id
        })
        .then(res => {
          let { enterprise, project, contractScale } = res.data.data;
          project.contractScale = contractScale;
          project.enterpriseName = enterprise.enterpriseName;
          project.price = moneyInt(project.price);
          this.ruleForm = project;
          this.ruleForm.taskSum ? '' : (this.ruleForm.taskSum = 0);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.button-margin-top {
  margin-top: 77px;
  .el-button {
    border-radius: 2px;
    float: left;
    &:nth-child(n + 2) {
      margin-left: 20px;
    }
  }
}
//中间背景留白 /对照UI
.academy-addedit-wrap {
  height: 100%;
  > .el-form {
    height: 100%;
  }
  .el-form-item {
    margin-bottom: 20px;
    .el-input {
      /*输入框宽度*/
      width: 300px;
      &.yuan {
        /*输入框后面追加<元>*/
        &:after {
          content: '元';
          margin-left: 10px;
          position: absolute;
        }
      }
    }
    &.input-width {
      /*项目单价和总任务量输入框宽度*/
      .el-input {
        width: 140px;
      }
    }
  }
}
</style>
